import { Component, Input } from '@angular/core';
import { FormControl } from '@angular/forms';

import { ValidationsService } from '@core/services/validations.service';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'control-messages',
  templateUrl: './control-messages.component.html'
})
export class ControlMessagesComponent {
  public errorsMessage: string;

  @Input() control: FormControl;

  constructor() {}

  get errorMessage() {
    for (const propertyName in this.control.errors) {
      if (
        this.control.errors.hasOwnProperty(propertyName) &&
        this.control.touched
      ) {
        return ValidationsService.getValidatorErrorMessage(
          propertyName,
          this.control.errors[propertyName]
        );
      }
    }

    return null;
  }
}
